// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [19,[2]],
		"/(app)/(wizard)/(pre-submission)/account/account-access": [29,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/activity": [30,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/banking-information": [31,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/tax-election": [32,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/type": [33,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/joint": [34,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/account": [35,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/beneficiary-inherited": [36,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/decedent-name": [37,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/individual": [38,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/select": [39,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiaries": [40,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-address": [41,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-details": [42,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-name": [43,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/trust-beneficiary": [44,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/type-of-beneficiary": [45,[2,3,7,8,9]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/estate-percentage-allocation": [46,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/secondary-owner": [47,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/investment-time-horizon": [48,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/risk-tolerance": [49,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/financial-information": [50,[2,3,7,8,10]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/instruments-knowledge": [51,[2,3,7,8,10]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/trading-objective": [52,[2,3,7,8,10]],
		"/(app)/(wizard)/(pre-submission)/account/trading-method": [53,[2,3,7,8]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/foreign-financial-institution": [54,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/legal-exemption": [55,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/select": [56,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-address": [57,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-details": [58,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-name": [59,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-tax-info": [60,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owners-table": [61,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/confirm-none": [62,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/individual": [63,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-entity": [64,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-individual": [65,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/information/basics": [66,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/information/company-secretary": [67,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/information/mailing-address": [68,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/information/primary-address": [69,[2,3,7,11]],
		"/(app)/(wizard)/(pre-submission)/business/relationship": [70,[2,3,7,11]],
		"/(session)/confirmation": [114,[18]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload": [71,[2,3,7,12,13]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/address-opt-out": [72,[2,3,7,12,13]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/confirm": [73,[2,3,7,12,13]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/entity-upload": [74,[2,3,7,12,13]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/upload": [75,[2,3,7,12,13]],
		"/(app)/(wizard)/(pre-submission)/documents/important-documents": [76,[2,3,7,12]],
		"/(app)/done/auto-approved": [109,[2,17]],
		"/(app)/done/documents-required": [110,[2,17]],
		"/(app)/done/instant-buying-power": [111,[2,17]],
		"/(app)/done/joint-continuation": [112,[2,17]],
		"/(app)/done/needs-review": [113,[2,17]],
		"/(session)/joint-continuation-signup": [115,[18]],
		"/(session)/joint-continuation-signup/success": [116,[18]],
		"/(session)/login": [117,[18]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/industry": [77,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/political": [78,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/public-company": [79,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/select": [80,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/citizenship": [81,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/residency": [82,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/visa": [83,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/mailing-address": [84,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/name": [85,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/phone-number": [86,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/physical-address": [87,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/employment-status": [88,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/job-details": [89,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/birth-date": [90,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/family": [91,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/subject-to-tax-withholding": [92,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/tax-number": [93,[2,3,7,14]],
		"/(app)/(wizard)/(pre-submission)/security/security-question": [94,[2,3,7,15]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/authenticator": [95,[2,3,7,15]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/method-selection": [96,[2,3,7,15]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/setup": [97,[2,3,7,15]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/sms": [98,[2,3,7,15]],
		"/(app)/(wizard)/(post-submission)/setup/cryptocurrency-trading": [20,[2,3,4,5]],
		"/(app)/(wizard)/(post-submission)/setup/funding/confirm-deposit": [21,[2,3,4,5]],
		"/(app)/(wizard)/(post-submission)/setup/funding/deposit": [22,[2,3,4,5]],
		"/(app)/(wizard)/(post-submission)/setup/funding/link-bank": [23,[2,3,4,5]],
		"/(app)/(wizard)/(post-submission)/setup/sms-notifications": [24,[2,3,4,5]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/add-trusted-contact": [25,[2,3,4,5,6]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/address": [26,[2,3,4,5,6]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/contact-info": [27,[2,3,4,5,6]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/personal-info": [28,[2,3,4,5,6]],
		"/(session)/signup": [118,[18]],
		"/(session)/signup/account-type": [119,[18]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/foreign-financial-institution": [99,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/select": [100,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor-details": [102,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor": [101,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/information/basics": [103,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/information/mailing-address-details": [104,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/information/primary-address": [105,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/information/same-mailing-address": [106,[2,3,7,16]],
		"/(app)/(wizard)/(pre-submission)/trust/review": [107,[2,3,7,16]],
		"/(app)/[...catchAll]": [108,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';